"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStatuses = void 0;
exports.MatchStatuses = {
    NOT_STARTED: 0,
    FIRST_BREAK: 301,
    SECOND_BREAK: 302,
    THIRD_BREAK: 303,
    FOURTH_BREAK: 304,
    FIFTH_BREAK: 305,
    SIXTH_BREAK: 306,
    FIRST_INNING_TOP: 401,
    FIRST_INNING_BOTTOM: 402,
    SECOND_INNING_TOP: 403,
    SECOND_INNING_BOTTOM: 404,
    THIRD_INNING_TOP: 405,
    THIRD_INNING_BOTTOM: 406,
    FOURTH_INNING_TOP: 407,
    FOURTH_INNING_BOTTOM: 408,
    FIFTH_INNING_TOP: 409,
    FIFTH_INNING_BOTTOM: 410,
    SIXTH_INNING_TOP: 411,
    SIXTH_INNING_BOTTOM: 412,
    SEVENTH_INNING_TOP: 413,
    SEVENTH_INNING_BOTTOM: 414,
    EIGHTH_INNING_TOP: 415,
    EIGHTH_INNING_BOTTOM: 416,
    NINTH_INNING_TOP: 417,
    NINTH_INNING_BOTTOM: 418,
    EXTRA_INNING_TOP: 419,
    EXTRA_INNING_BOTTOM: 420,
    BREAK_TOP_1_BOTTOM_1: 421,
    BREAK_TOP_2_BOTTOM_1: 422,
    BREAK_TOP_2_BOTTOM_2: 423,
    BREAK_TOP_3_BOTTOM_2: 424,
    BREAK_TOP_3_BOTTOM_3: 425,
    BREAK_TOP_4_BOTTOM_3: 426,
    BREAK_TOP_4_BOTTOM_4: 427,
    BREAK_TOP_5_BOTTOM_4: 428,
    BREAK_TOP_5_BOTTOM_5: 429,
    BREAK_TOP_6_BOTTOM_5: 430,
    BREAK_TOP_6_BOTTOM_6: 431,
    BREAK_TOP_7_BOTTOM_6: 432,
    BREAK_TOP_7_BOTTOM_7: 433,
    BREAK_TOP_8_BOTTOM_7: 434,
    BREAK_TOP_8_BOTTOM_8: 435,
    BREAK_TOP_9_BOTTOM_8: 436,
    BREAK_TOP_9_BOTTOM_9: 437,
    BREAK_TOP_EI_BOTTOM_9: 438,
    BREAK_TOP_EI_BOTTOM_EI: 439,
};
//# sourceMappingURL=matchStatuses.js.map